<template>
  <v-container class="pa-0">
    <v-card flat rounded="0" class="py-4">
      <BeneficiaryCard />
      <template v-if="displayFooter">
        <v-divider></v-divider>
        <USBeneficiaryCard v-if="isUsPolicyCode && !isRestrictedPolicy" />
        <NYBeneficiaryCard v-else-if="isNyPolicyCode && !isRestrictedPolicy" />
        <CABeneficiaryCard
          v-else-if="isCanadaPolicyCode && !isRestrictedPolicy"
          :is-quebec="isCanadaQuebec"
        />
        <BeneficiaryDefault v-else />
      </template>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import USBeneficiaryCard from './BeneficiariesUSBeneficiaryCard.vue';
import NYBeneficiaryCard from './BeneficiariesNYBeneficiaryCard.vue';
import CABeneficiaryCard from './BeneficiariesCABeneficiaryCard.vue';
import BeneficiaryDefault from './BeneficiariesBeneficiaryDefault.vue';
import BeneficiaryCard from './BeneficiariesBeneficiaryCard.vue';
import { FEATURE_FLAGS } from '@/shared/models/constants.models';
import { mapState } from 'pinia';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';

const componentOptions: ComponentOptions = {
  name: 'BeneficiariesComponent',
  components: {
    USBeneficiaryCard,
    NYBeneficiaryCard,
    CABeneficiaryCard,
    BeneficiaryDefault,
    BeneficiaryCard,
  },
  props: {
    isRestrictedPolicy: {
      type: Boolean,
      default: false,
    },
    isUsPolicyCode: {
      type: Boolean,
      default: true,
    },
    isNyPolicyCode: {
      type: Boolean,
      default: false,
    },
    isCanadaPolicyCode: {
      type: Boolean,
      default: false,
    },
    isCanadaQuebec: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(usePolicyStore, {
      isPending: 'isPending',
      policy: 'currentPolicy',
    }),
    ...mapState(useGlobalStore, ['containsFeature', 'features']),
    displayFooter() {
      return (
        this.isPending ||
        !this.containsFeature(FEATURE_FLAGS.BENEFICIARIES_EDIT) ||
        !this.policy.allowEditBeneficiary
      );
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss">
.beneficiaries-subtitle {
  margin-top: 16px !important;
  font-size: 1.25rem !important;
}

.beneficiaries-phone {
  margin-top: 16px !important;
  font-size: 1.25rem !important;
}

.beneficiaries-subtext {
  padding-left: 24px;
  padding-right: 24px;

  @media (min-width: 600px) {
    padding-left: 100px;
    padding-right: 100px;
  }
}

.beneficiaries-for-more-information {
  display: block;

  @media (min-width: 600px) {
    display: inline;
    margin-left: 8px;
  }
}
</style>
